import type { Context } from '@nuxt/types';
import { jobSearchStatusKeys } from '@/components/partials/war-room-onboarding/constants';
import { REFERER_IS_JOB_POSTING_LINK, IS_SELECTED_JOBS_PRODUCT } from '~/components/partials/jobs/constants';

export default async function onboardingV3(ctx: Context) {
  const { app, store, $api } = ctx;
  const { $cookies } = app;

  const { warRoomIsInterestingToJobSurvey, ...onboardingProfile } = store.state.warRoom.onboardingProfile;
  if (!Object.prototype.hasOwnProperty.call(onboardingProfile, 'username')) {
    await store.dispatch('warRoom/fetchOnboardingProfile');
  }

  // skip first 2 onboarding page for users coming from job posting
  // and set values inside the profile.
  // FIXME: perhaps we could do that logic just inside components?
  if ($cookies.get(REFERER_IS_JOB_POSTING_LINK) || $cookies.get(IS_SELECTED_JOBS_PRODUCT)) {
    if (!warRoomIsInterestingToJobSurvey) {
      const user = {
        war_room_is_interesting_to_job_survey: true,
        war_room_job_search_status: jobSearchStatusKeys.ACTIVELY_LOOKING,
      };
      await $api.$put('/api/war_room/user.json', {
        user,
      });

      // FIXME use mutation updateOnboardingProfile, not direct
      // update onboardingProfile
      store.commit('warRoom/updateState', {
        onboardingProfile: {
          warRoomJobSearchStatus: user.war_room_job_search_status,
          warRoomIsInterestingToJobSurvey: user.war_room_is_interesting_to_job_survey,
        },
      });
    }
  }
}
